import { render, staticRenderFns } from "./CreateMilestoneAward.vue?vue&type=template&id=7374029e&scoped=true&"
import script from "./CreateMilestoneAward.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateMilestoneAward.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateMilestoneAward.vue?vue&type=style&index=0&id=7374029e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7374029e",
  null
  
)

export default component.exports